var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.Image)?_c('v-img',{style:({ 'width': _vm.isSimulation ? '375px' : (_vm.sizeW + "px !important")}),attrs:{"src":_vm.data.Image}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }